import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { ProductLookupComponent } from './app/landing-pages/product-lookup/product-lookup.component';
import { provideHttpClient } from '@angular/common/http';
import { provideToastr } from 'ngx-toastr';
import { provideRouter } from '@angular/router';
import { routes } from './app/landing-pages/product-lookup/product-lookup.routes';

if (environment.production) {
  enableProdMode();
}

const hostname = window.location.hostname;

if (hostname.startsWith('tracuu.')) {
  bootstrapApplication(ProductLookupComponent, {
    providers: [
      provideHttpClient(),
      provideToastr(),
      provideRouter(routes)
    ]
  })
} else {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
}